import { useCallback } from 'react';

import { EmptyStatePlaceholder, Link, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { visitHistoryTranslationKeys, visitTranslationKeys } from '../translations';

type VisitHistoryInfiniteListPlaceholderProps = {
   readonly patientId: number;
};

export const VisitHistoryInfiniteListPlaceholder = (props: VisitHistoryInfiniteListPlaceholderProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);

   const handleClick = useCallback(
      (): void =>
         push(
            visitPaths.getCalendarPath({
               searchParams: {
                  bookPatientId: props.patientId,
               },
            }),
            {
               label: visitTranslationKeys.goBackToVisitHistory,
            }
         ),
      [push, props.patientId]
   );

   return (
      <EmptyStatePlaceholder
         testId={'noVisitHistory'}
         heading={visitHistoryTranslationKeys.noVisitHistory}
         subheading={visitHistoryTranslationKeys.patientHasNotHadAnyVisits}
      >
         <Link testId={'bookVisit'} label={visitHistoryTranslationKeys.bookVisit} onClick={handleClick} />
      </EmptyStatePlaceholder>
   );
};
